// LiveStreamPusherHandler.js
import { connect } from 'react-redux';

import { JWT_SCOPE_LIVESTREAM_MODERATOR } from '../RemoteConfigKeys.js';

import LiveStreamPusherHandler from '../component/LiveStreamPusherHandler.jsx';
import subscribeStreamChannel from '../action/subscribeStreamChannel.js';
import unsubscribeStreamChannel from '../action/unsubscribeStreamChannel.js';
import subscribePrivateStreamViewerV2Channel from '../action/subscribePrivateStreamViewerV2Channel.js';
import unsubscribePrivateStreamViewerV2Channel from '../action/unsubscribePrivateStreamViewerV2Channel.js';
import subscribePrivateGoalV2Channel from '../action/subscribePrivateGoalV2Channel.js';
import unsubscribePrivateGoalV2Channel from '../action/unsubscribePrivateGoalV2Channel.js';
import {
  subscribePresenceStreamExclusive,
  unsubscribePresenceStreamExclusive,
} from '../action/presenceStreamExclusiveChannelHandler.js';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getMeData from '../selector/getMeData.js';
import getGoalData from '../selector/getGoalData.js';
import getIsPermissionMatched from '../selector/getIsPermissionMatched.js';

const mapStateToProps = (state, { streamId }) => {
  const pusherPreset = getLiveStreamData(state, [streamId], 'pusherPreset');
  const meId = getMeData(state, 'id');
  const fundingId = getLiveStreamData(
    state,
    [streamId, 'privateShow'],
    'fundingId'
  );
  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );
  const currentExclusivePrivateId = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'currentId'
  );
  const exclusivePrivateBuyerId = getGoalData(
    state,
    [currentExclusivePrivateId, 'context'],
    'exclusive_to'
  );

  const isLivestreamModerator = getIsPermissionMatched(
    state,
    JWT_SCOPE_LIVESTREAM_MODERATOR
  );
  return {
    pusherPreset,
    meId,
    fundingId,
    exclusivePrivateStatus,
    exclusivePrivateBuyerId,
    isLivestreamModerator,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    subscribeStreamChannel: data => dispatch(subscribeStreamChannel(data)),
    unsubscribeStreamChannel: data => dispatch(unsubscribeStreamChannel(data)),
    subscribePrivateStreamViewerV2Channel: data =>
      dispatch(subscribePrivateStreamViewerV2Channel(data)),
    unsubscribePrivateStreamViewerV2Channel: data =>
      dispatch(unsubscribePrivateStreamViewerV2Channel(data)),
    subscribePrivateGoalV2Channel: data =>
      dispatch(subscribePrivateGoalV2Channel(data)),
    unsubscribePrivateGoalV2Channel: data =>
      dispatch(unsubscribePrivateGoalV2Channel(data)),
    subscribePresenceStreamExclusive: data =>
      dispatch(subscribePresenceStreamExclusive(data)),
    unsubscribePresenceStreamExclusive: data =>
      dispatch(unsubscribePresenceStreamExclusive(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamPusherHandler);
